"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _menu = require("../../basic/menu");

var _menu2 = _interopRequireDefault(_menu);

var _icon = require("../../basic/icon");

var _icon2 = _interopRequireDefault(_icon);

var _loader = require("../../tools/loader");

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SubMenu = _menu2["default"].SubMenu;
var MenuItemGroup = _menu2["default"].ItemGroup;

var Sidebar = _react2["default"].createClass({
  displayName: "Sidebar",
  getDefaultProps: function getDefaultProps() {
    return {
      init: "index",
      list: [{}]
    };
  },
  getInitialState: function getInitialState() {
    return {
      current: this.props.init,
      toRender: null
    };
  },
  handleClick: function handleClick(e) {
    this.setState({
      current: e.key
    });
    _loader2["default"].loadUrl(e.key);
  },
  render: function render() {
    var dummyKey = 0;
    var createNode = function createNode(node) {
      var toReturn = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = node[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (typeof item.children == "undefined" || item.children.length == 0) {
            toReturn.push(_react2["default"].createElement(
              _menu2["default"].Item,
              { key: item.url || (dummyKey++).toString() },
              item.name || ""
            ));
          } else {
            toReturn.push(_react2["default"].createElement(
              SubMenu,
              { key: item.url || (dummyKey++).toString(), title: _react2["default"].createElement(
                  "span",
                  null,
                  _react2["default"].createElement(_icon2["default"], { type: item.icon || "appstore" }),
                  _react2["default"].createElement(
                    "span",
                    null,
                    item.name
                  )
                ) },
              createNode(item.children)
            ));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"]) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return toReturn;
    };
    var toRender = null;
    if (this.props.list && this.props.list.length > 0) toRender = createNode(this.props.list);
    return _react2["default"].createElement(
      _menu2["default"],
      { onClick: this.handleClick,
        style: { "width": "15%", "float": "left", "minHeight": "600px" },
        defaultOpenKeys: this.props.list.defaultOpenKeys,
        selectedKeys: [this.state.current],
        mode: "inline" },
      _react2["default"].createElement("li", null),
      toRender || _react2["default"].createElement(
        _menu2["default"].Item,
        { key: "loading", disabled: true },
        "loading"
      ),
      _react2["default"].createElement("li", null)
    );
  }
});

exports["default"] = Sidebar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/frame/sidebar.jsx
 ** module id = 617
 ** module chunks = 0
 **/